import axios from "axios";
import { initCopyScript } from "../../helpers/copy-handler";
import { updateCifsShareExpiration } from "../../helpers/expiration-handler";

const initViewCloudShareLink = () => {
  document.querySelectorAll('.js-view-cloud-share-link').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const currentElement = e.currentTarget;
      if (currentElement.classList.contains('disabled')) {
        return;
      }
      currentElement.classList.add('disabled');

      const originalText = currentElement.textContent;
      currentElement.textContent = currentElement.dataset.busyText;

      const shareId = currentElement.dataset.shareId;

      const flowContainer = document.createElement('div');
      flowContainer.setAttribute('data-flow-name', 'recovery')
      document.getElementById('content').prepend(flowContainer);

      const stepContainer = document.createElement('div');
      stepContainer.className = 'stepcontainer';
      flowContainer.appendChild(stepContainer);

      axios.get(`/client/load_cloud_link/${shareId}`, {
        responseType: 'text'
      })
        .then(response => {
          stepContainer.innerHTML = response.data;
          initCopyScript();

          currentElement.textContent = originalText;
          currentElement.classList.remove('disabled');
        }).catch(() => {
        currentElement.textContent = currentElement.dataset.errorText;
      })
    })
  })
};

const initExpireCloudShareLink = (cloudSharesDialogData) => {
  document.querySelectorAll('.js-load-expire-cloud-share-link').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const currentElement = e.target;
      if (currentElement.classList.contains('disabled')) {
        return;
      }
      currentElement.classList.add('disabled');
      const originalText = currentElement.textContent;
      currentElement.textContent = currentElement.dataset.busyText;

      const shareId = currentElement.dataset.shareId;

      const flowContainer = document.createElement('div');
      flowContainer.setAttribute('data-flow-name', 'recovery');
      document.getElementById('content').prepend(flowContainer);

      const stepContainer = document.createElement('div');
      stepContainer.className = 'stepcontainer';
      flowContainer.appendChild(stepContainer);

      axios.get(`/dialog/expire_cloud_link`, {
        responseType: 'text'
      }).then(response => {
          stepContainer.innerHTML = response.data;

          document.querySelectorAll('[data-flow-close="1"]').forEach(closeElement => {
            closeElement.addEventListener('click', () => {
              document.querySelectorAll('div[data-flow-name]').forEach(element => element.remove());
            });
          });
          // Expire link click
          stepContainer.querySelectorAll('.js-expire-cloud-link').forEach(button => {
            button.addEventListener('click', () => {
              flowContainer.innerHTML = '';
              axios.get(`/ra/expire_cloud_link/${shareId}`)
                .then(response => {
                if (response.data.ok) {
                  loadResellerCloudSharesActivities(cloudSharesDialogData);
                } else {
                  currentElement.textContent = currentElement.dataset.errorText;
                }
              })
            })
          });

          currentElement.textContent = originalText;
          currentElement.classList.remove('disabled');
        }).catch(() => {
        currentElement.textContent = currentElement.dataset.errorText;
      });
    })
  })
};

const loadResellerCloudSharesActivities = (cloudSharesDialogData) => {
  axios.get(`/reseller/get_reseller_cloud_shares/${cloudSharesDialogData.resellerId}`)
    .then(response => {
      showCloudSharesActivities(response, cloudSharesDialogData);
      updateCifsShareExpiration();
    });
};

const showCloudSharesActivities = (response, cloudSharesDialogData) => {
  const currentCloudShares = document.querySelector(`.feed-table-interest .cloud_shares`);
  if (currentCloudShares) {
    currentCloudShares.remove();
  }

  const nothingRecent = document.querySelector(`.feed-table-interest .nothingrecent`);
  if (nothingRecent) {
    nothingRecent.remove();
  }

  const activitiesTable = document.querySelector(`.feed-table-interest`);
  if (!activitiesTable) {
    return;
  }

  if (response.data.cloud_shares.length > 0) {
    const cloudSharesActivitiesHtml = Handlebars.compile(atob(cloudSharesDialogData.resellerCloudSharesActivitiesTemplate))({
      shares: response.data.cloud_shares,
    });
    activitiesTable.insertAdjacentHTML('afterbegin', cloudSharesActivitiesHtml);
  }

  const activities = activitiesTable.querySelectorAll(`.feed-table-interest .feed-row`);
  if (activities.length > 0) {
    const activitiesHeader = document.querySelector(`.collapsible-feed .header.pointer`);
    if (activitiesHeader) {
      activitiesHeader.classList.add('expanded');
    }

    activitiesTable.style.display = '';
  }

  initViewCloudShareLink();
  initExpireCloudShareLink(cloudSharesDialogData);
};

export { loadResellerCloudSharesActivities };
